<button *ngIf="achCustomerId" pButton type="button" class="icon-action" icon="fa fa-pencil" pTooltip="Edit Customer In Dwolla" tooltipPosition="top"
        (click)="onClickEditCustomer()">
</button>

<p-dialog *ngIf="displayEditDialog" [(visible)]="displayEditDialog">
  <div class="instruction-text">
    Any updates has to come through the Resource Management Record.
    This option is provided only for CSR's to update information when the update cannot be made from HR record.
    Use this cautiously.
  </div>
  <form #updateCustomerForm="ngForm">
  <div class="p-grid">
    <div class="p-col-12 p-md-5 p-lg-5">
      <label>Reference Id</label>
    </div>
    <div class="p-col-12 p-md-7 p-lg-7">
      {{achCustomerId}}
    </div>
  </div>

    <div class="p-grid">
      <div class="p-col-12 p-md-5 p-lg-5">
        <label>First Name</label>
      </div>
      <div class="p-col-12 p-md-7 p-lg-7">
        {{dwollaCustomer.firstName}}
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-md-5 p-lg-5">
        <label>Last Name</label>
      </div>
      <div class="p-col-12 p-md-7 p-lg-7">
        {{dwollaCustomer.lastName}}
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-12 p-md-5 p-lg-5">
        <label>Email</label>
      </div>
      <div class="p-col-12 p-md-7 p-lg-7">
        <input pInputText name="pEmail" type="text" [pattern]="RegExpEmailWithAlias" [maxLength]="Validation.WorkEmailMaxLength"
               [(ngModel)]="dwollaCustomer.email" required>
      </div>
    </div>

  </form>

  <p-footer>
    <div class="p-col-12" style="text-align:right;">
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Close"
              (click)="onClickCancel()"></button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Update"
              [disabled]="!updateCustomerForm?.form.valid"
              (click)="onClickUpdate(achCustomerId)"></button>
    </div>
  </p-footer>

</p-dialog>
